import { useEffect, useState } from 'react'
import getSuppliersList from '../../../controllers/settings/supplier/getSuppliersList';
import { enqueueSnackbar } from 'notistack';
import TextInput from '../TextInput';
import { CircularProgress, MenuItem } from '@mui/material';


export default function SuppliersInput({data: defData, callback}) {
    const [loadings, setLoadings] = useState({submit: false,suppliers: false});
    const [suppliers, setSuppliers] = useState([]);
    const [data,setData] = useState({suppliers: defData || []});

    function handleChange(newData) {
        setData(newData);
        callback && callback(newData?.suppliers);
    }
    
    useEffect(() => {
        loadSuppliers();
        //eslint-disable-next-line
    }, []);
    
    async function loadSuppliers() {
        setLoadings({...loadings,suppliers: true});
        const res = await getSuppliersList();
        setLoadings({...loadings,suppliers: false});
        if (res?.return) {
        setSuppliers(res?.data);
        } else {
        enqueueSnackbar(res?.msg, { variant: "error" });
        }
    }

    // const Card = ({data,remove}) => {
    //     return (
    //         <div className='flex gap-2 items-center rounded-full px-2 bg-secondary shadow'>
    //             <span className='text-sm'>{data}</span>
    //             <Icon icon='mdi:close' onClick={() => remove && remove()} className='text-red-500 cursor-pointer' />
    //         </div>
    //     )
    // }
        
  return (
    <div className='flex flex-col gap-4'>
        {/* <div className='flex gap-2 items-center max-w-full overflow-x-auto'>
            {data?.suppliers?.map((obj, i) => (
                <Card data={obj} key={i} remove={() => {}} />
            ))}
        </div> */}
        <TextInput label='Suppliers' select required
            SelectProps={{ multiple: true }}
            value={data?.suppliers || []}
            onChange={(ev) => handleChange({...data,suppliers: ev?.target?.value})}
            InputProps={{
              endAdornment: (
                <span className="text-primary/50 font-light mr-6 flex items-center">
                  {loadings?.suppliers ? 
                    <CircularProgress size={18} className="!text-theme1" />
                  :null}
                </span>
              )
            }}
          >
            {suppliers?.map((obj,i) => (
              <MenuItem key={i} value={obj.value}>{obj?.value}</MenuItem>
            ))}
        </TextInput>
    </div>
  )
}
